module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/univ-alabama-83d85fac6c580f018bc125bd9edce41e.svg";